<app-item>
	<div class="rounded-border-box label-value" (click)="controlClicked()">
		<app-item-label class="validation-label">{{ label }}</app-item-label>
		@if (readOnly) {
			<app-item-value [value]="quantity"></app-item-value>
		}
		@else {
			<app-item-input [placeholder]="placeholder" [value]="quantity" [maxlength]="maxlength" [inputMode]="inputMode!" (valueChange)="quantityChanged($event)" (itemFocus)="itemFocused()"></app-item-input>
		}
	</div>
	@if (unit) {
		<app-item-label class="rounded-border-box unit-label">{{ unit }}</app-item-label>
	}
	<app-item-label class="rounded-border-box unit-select" [class]="highlightClass" (click)="presentAbnormalFlagPopover($event)">
		<app-abnormal-flag-indicator class="no-events" [flag]="abnormalFlag"></app-abnormal-flag-indicator>
	</app-item-label>
	<app-item-label class="rounded-border-box range-label">{{ range }}</app-item-label>
</app-item>